export const API_URL = 'https://api.friendlybet.org';
export const MAIN_PUBLIC_LINK = 'https://g.friendlybet.org?id=';
export const LANGUAGES_TO_FLAGS = { en: 'gb', fi: 'fi' };
